import Utils from "../services/utils";

export default class Admin {
  constructor(data) { // response.data
    if (!data) {
      this.id = null;
      this.version = 0;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.locale = null;
      this.companyName = null;
      this.folderName = null;
      this.responsibleId = null;
      this.passwordNew = null;
      this.passwordNewConfirm = null;
    } else {
      this.id = data.id;
      this.version = data.version;
      this.firstName = data.firstName.normalize();
      this.lastName = data.lastName.normalize();
      this.email = data.email;
      this.locale = data.locale;
      this.companyName = data.companyName.normalize();
      this.folderName = data.folderName;
      this.responsibleId = data.responsibleId;
      this.passwordNew = null;
      this.passwordNewConfirm = null;
    }
  }

  beforeSubmit() {
    if (Utils.isBlank(this.passwordNew)) {
      this.passwordNew = null;
    }
    if (Utils.isBlank(this.passwordNewConfirm)) {
      this.passwordNewConfirm = null;
    }
  }

  get displayName() {
    let displayName = this.firstName == null ? "" : this.firstName + " ";
    displayName += this.lastName == null ? "" : this.lastName;
    return displayName;
  }
}



// WEBPACK FOOTER //
// ./src/models/Client.js